<template>
  <div class="common-box">
    <el-form
      inline
      ref="form"
      class="search-form common-box-search-form"
      label-position="right"
      :model="form"
      label-width="70px"
    >
      <search-form @search="handleSearch" @refresh="handleRefresh">
        <div slot="content">
          <el-form-item label="模板名称：">
            <el-input
              @change="handleSearchListData"
              size="mini"
              v-model.trim="form.templateName"
              placeholder="请输入模板名称"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="电梯类型：">
            <el-select
              size="mini"
              v-model="form.liftTypeCode"
              placeholder="请选择电梯类型"
              clearable
              filterable
              @change="handleSearchListData"
            >
              <el-option
                v-for="item in dtlxDicts"
                :key="item.dictionaryCode"
                :label="item.dictionaryValue"
                :value="item.dictionaryCode"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
      </search-form>
    </el-form>
    <div class="common-cover-div"></div>
    <div class="operation-and-table__container">
      <div class="btns__container">
        <el-button
          v-if="hasRole['BYMBTJ']"
          size="mini"
          type="primary"
          class="plr28"
          @click="handleAdd"
        >添加</el-button>
        <el-button
          size="mini"
          type="primary"
          class="plr28"
          @click="handleDelete"
          plain
          v-if="hasRole['BYMBSC']"
        >删除</el-button>
        <el-button
          size="mini"
          type="primary"
          @click="exportTemplate"
          plain
          class="plr28"
          v-if="hasRole['BYMBDC']"
        >导出</el-button>
      </div>
      <div class="table__container">
        <el-table
          v-loading="tableLoading"
          :data="list"
          height="100%"
          border
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="40"></el-table-column>
          <el-table-column show-overflow-tooltip prop="templateName" label="模板名称" width="260"></el-table-column>
          <el-table-column show-overflow-tooltip prop="liftTypeName" label="电梯类型" width="100"></el-table-column>
          <el-table-column show-overflow-tooltip prop="itemNum" label="保养项数量" width="100"></el-table-column>
          <el-table-column show-overflow-tooltip prop="liftNum" label="电梯数量" width="100"></el-table-column>
          <el-table-column show-overflow-tooltip prop="contactsPhone" label="备注信息"></el-table-column>
          <el-table-column label=" " prop=" "></el-table-column>
          <el-table-column label="操作" width="212px" fixed="right">
            <template slot-scope="scope">
              <el-button
                size="mini"
                v-if="hasRole['BYMBWBX']"
                type="text"
                @click="jumpMaintenanceItems(scope.row)"
              >维保项</el-button>
              <div class="btn-divide" v-if="hasRole['BYMBWBX']"></div>
              <el-button
                size="mini"
                v-if="hasRole['BYMBBJ']"
                type="text"
                @click="handleEdit(scope.row)"
              >编辑</el-button>
              <div class="btn-divide" v-if="hasRole['BYMBBJ']"></div>
              <el-button
                size="mini"
                v-if="hasRole['BYMBFZ']"
                type="text"
                @click="handleEditCopy(scope.row)"
              >复制</el-button>
              <div class="btn-divide" v-if="hasRole['BYMBFZ']"></div>
              <el-button
                size="mini"
                v-if="hasRole['BYMBSC']"
                type="text"
                @click="handleDeleteTemplate(scope.row)"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagenation__container">
        <div class="for-fff-bg">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageIndex"
            :page-sizes="[25, 50, 100, 150, 200]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
    <add-template
      v-if="addTemplateVisible"
      @cancel="addTemplateVisible = false"
      @confirm="handleAddTemplateConfirm"
    ></add-template>
    <edit-template
      v-if="editTemplateVisible"
      :editData="templateDetail"
      @cancel="editTemplateVisible = false"
      @confirm="handleEditTemplateConfirm"
    ></edit-template>
    <check-department
      v-if="checkDepartment"
      :editData="templateDetail"
      @cancel="checkDepartment = false"
    ></check-department>
  </div>
</template>

<script>
import {
  getMaintainTemplateList,
  deleteTemplate,
  exportTemplate,
} from "@/api/MaintenanceTemplate";

import AddTemplate from "./components/AddTemplate";
import EditTemplate from "./components/EditTemplate";
import CheckDepartment from "./components/CheckDepartment";
import { mapState } from "vuex";
export default {
  name: "MaintenanceTemplate",
  components: {
    AddTemplate,
    EditTemplate,
    CheckDepartment,
  },
  data() {
    return {
      form: {
        templateName: "",
        liftTypeCode: "",
      },
      tableLoading: false,
      list: [],
      multipleSelection: [],
      pageIndex: 1,
      pageSize: 50,
      total: 0,
      addTemplateVisible: false,
      editTemplateVisible: false,
      checkTemplateVisible: false,
      checkDepartment: false,
      templateDetail: {},
    };
  },
  computed: {
    hasRole: function () {
      return this.$store.getters["common/promise/getRole"](this.$route.path);
    },
    ...mapState("common/dictionary", ["dtlxDicts"]),
  },
  created() {
    this.getListData();
  },
  methods: {
    async getListData() {
      this.tableLoading = true;
      const params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };
      for (let key in this.form) {
        if (this.form[key]) params[key] = this.form[key];
      }
      const res = await getMaintainTemplateList(params);
      if (res.code === 200) {
        this.total = res.data.total;
        this.list = res.data.list;
      }
      this.tableLoading = false;
    },
    handleSearch() {
      this.pageIndex = 1;
      this.getListData();
    },
    handleRefresh() {
      for (let key in this.form) {
        if (Array.isArray(this.form[key])) {
          this.form[key] = [];
        } else {
          this.form[key] = "";
        }
      }
      this.pageIndex = 1;
      this.getListData();
    },
    handleSearchListData() {
      this.pageIndex = 1;
      this.getListData();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleDeleteTemplate(row) {
      const idList = [row.id];
      this.deleteTemplate(idList);
    },
    handleCheck(row) {
      this.templateDetail = row;
      this.checkDepartment = true;
    },
    handleEdit(row) {
      this.templateDetail = row;
      this.editTemplateVisible = true;
    },
    handleEditCopy(row) {
      this.templateDetail = {...row};
      this.templateDetail.copy = true
      this.templateDetail.templateName = ''
      this.editTemplateVisible = true;
    },
    handleDelete() {
      if (!this.multipleSelection.length) {
        this.$message.warning("请选择要删除的行");
        return;
      }
      const idList = this.multipleSelection.map((item) => item.id);
      this.deleteTemplate(idList);
    },
    deleteTemplate(idList) {
      this.$confirm("确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const res = await deleteTemplate({ idList });
          if (res.code === 200) {
            this.$message.success("删除成功");
            this.getListData();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleAdd() {
      this.addTemplateVisible = true;
    },
    exportTemplate() {
      const params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };
      for (let key in this.form) {
        if (this.form[key]) params[key] = this.form[key];
      }
      exportTemplate(params);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getListData();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getListData();
    },
    handleAddTemplateConfirm() {
      this.addTemplateVisible = false;
      this.pageIndex = 1;
      this.getListData();
    },
    handleEditTemplateConfirm() {
      this.editTemplateVisible = false;
      this.getListData();
    },
    jumpMaintenanceItems(row) {
      this.$router.push({
        name: 'MaintenanceItems',
        params: {
          templateId: row.id
        }
      })
    }
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/MaintenanceTemplate/MaintenanceTemplate.vue